import { Component, OnInit } from '@angular/core';
import { ProfileService } from '../profile/profile.service';
import { Profile, ApiAccess } from '../models/profile.model';
import { NotificationBuilder } from '../shared/notificationBuilder';
import { HelperService } from '../services/helper.service';

declare var swal: any
declare var $: any

@Component({
  selector: 'app-referral',
  templateUrl: './referral.component.html',
  styleUrls: ['./referral.component.css']
})

export class ReferralComponent implements OnInit {
  profile: Profile
  referralList: Array<Profile>
  apiAccess: ApiAccess
  script: string = ""
  public isAdmin: boolean
  loading: boolean = false
  loadingMessage: string = "Conectando com a API. Isso pode demorar um pouco!"
  constructor(private profileService: ProfileService, private helperService: HelperService, private notificationBuilder: NotificationBuilder) {
  }

  ngOnInit() {
    debugger
    this.isAdmin = localStorage.getItem("admin-token") != null
    this.profileService.getCurrentUserInfo().subscribe(data => {
      debugger
      this.profile = data
      console.log(data)
      this.profileService.getReferralList().subscribe(model => {
        if (model.success) {
          this.referralList = model.referrals
        }
        else {
          this.notificationBuilder.showNotification('danger', 2000, data.errorMessage)
        }
      })
    })
  }

  sendToDeveloper() {

    swal({
      title: 'Enviar por E-mail',
      text: 'Envie aqui para quem vai adicionar o script. Leva em média 5 minutos!',
      html:
        '<input id="name-dev" class="swal2-input" placeholder="Nome">' +
        '<input id="email-dev" type="email" placeholder="E-mail" class="swal2-input">',
      focusConfirm: false
    })
      .then((ok) => {
        if (ok) {
          let name = $("#name-dev").val()
          let email = $("#email-dev").val()
          this.helperService.sendEmailScriptToDeveloper(email, name, this.profile.storeSeoName)
          swal({
            type: 'success',
            title: 'Script Enviado =)',
            text: 'Enviamos o script por e-mail para ' + name + '. De qualquer maneira, avisa ele(a) também. Leva menos de 5 para add o Polen ;)',
          })
        }
      })
  }

  copyToClipboard(id) {
    let script = document.getElementById(id) as HTMLInputElement
    script.select()
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = script.value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.notificationBuilder.showNotification('success', 1000, 'copiado no seu clipboard')
  }

  saveApiAccess() {
    debugger
    this.loading = true
    this.profileService.updateApiAccess(this.apiAccess).subscribe(data => {
      this.loading = false
      if (data != null) {
        this.notificationBuilder.showNotification('success', 7000, 'Chave de API salva... vamos verificar a validade em breve.')
      } else {
        this.notificationBuilder.showNotification('danger', 2000, data.error)
      }

    })
    // .error(data => {
    //   console.log(data)
    //   this.loading = false
    //   if (data.success) {
    //     this.notificationBuilder.showNotification('success', 1000, 'Chave de API salva... vamos verificar a validade em breve.')
    //   } else {
    //     this.notificationBuilder.showNotification('danger', 2000, data.error)
    //   }

    // })
  }
}
